// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import { categoryListQueryOptions } from '@/modules/category/category.hooks'
import { categorySearchSchema } from '@/modules/category/category.schemas'

export const categoryRoute = createRoute({
  path: '/categories',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const categoryListRoute = createRoute({
  getParentRoute: () => categoryRoute,
  path: '/',
  validateSearch: categorySearchSchema,
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'categories.list',
      'Kategori listesine erişim izniniz yok.'
    )
  },
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      categoryListQueryOptions(toAdminListParams(deps))
    )
  },
  head: () => ({
    meta: [
      {
        title: 'Kategori Listesi',
      },
    ],
  }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/category/pages/list-category.page')
  ),
})
